// Styles here will override Bulma styles
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import media from 'css-in-js-media';

export const StyledSubnote = styled.div`
  text-align: center;
`;

export const styledPricingSection = css`
  background-repeat: repeat;
  background-size: cover;
`;

export const styledPricingContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledRecommend = styled.span`
  position: absolute;
  right: 32px;
  color: white;
  font-size: 12px;
  background-color: #0069ff;
  border-radius: 50px;
  padding: 5px 10px;
`;

export const styledColHeading = css`
  margin: 0 16px 0 0;
`;

export const styledHeading = css`
  margin: 0 auto;
  text-align: center;
`;

export const styledSubtitle = css`
  margin: 20px auto 80px auto !important;
  max-width: 670px;
  text-align: center;
`;

export const StyledCards = styled.div`
  display: flex;
  max-width: 1170px;
  margin: 64px auto;
  box-shadow: 0px 8px 13px 0px #000000 5%;
  border-radius: 3px;
  .recommended {
    background-color: #f2f8ff;
    border: 1px solid #0069ff;
    position: relative;
  }
  ${media('< desktop')} {
    flex-direction: column;
    width: 95%;
  }
`;

export const StyledCol = styled.div`
  align-items: center;
  background-color: #fff;
  border: 1px solid #e5e8ed;
  border-radius: 5px;
  box-shadow: rgb(3 27 78 / 10%) 0px 10px 20px;
  display: flex;
  justify-content: center;
  min-width: 470px;
  padding: 16px 32px;
  &:first-of-type {
    margin-right: 32px;
  }
  ${media('< desktop')} {
    margin: 0 auto;
    width: 400px;
    &:first-of-type {
      margin-bottom: 32px;
      margin-right: auto;
    }
  }
  ${media('< phone')} {
    max-width: 320px;
    min-width: 0;
  }
  p {
    margin: 8px 0 0 0;
  }
`;

export const StyledPricing = styled.p`
  align-items: center;
  display: flex;
  color: #031b4e;
  font-family: 'WorkSans-Bold';
  height: 50px;
  margin: 32px 0 !important;
  span.price {
    font-size: 58px;
    padding: 0 6px;
  }
  span.currency {
    align-self: flex-start;
    font-size: 20px;
  }
  span.interval {
    align-self: flex-end;
    white-space: nowrap;
  }
`;
